module.exports = __webpack_public_path__ + "img/lang-fr-hover.863bd001.png";